import React from 'react'

import About from './About.jsx'

export default () => (
  <About id='about2'>
    かんたんな Web アプリケーションや研究用の実験ツールを作るのがすきです。動くとたのしいし、喜んでくれるともっとたのしい。
  </About>
)
